
export default {
  props: { headline: { type: String, default: () => '' } },
}
